import { Button, DatePicker, Form, message, Modal } from 'antd'
import { useTranslation } from 'react-i18next';
import { authFetch } from '../../../../../common/request/authFetch';
import { useAuth } from '../../../../../store/AuthContext/AuthContext';
import moment from 'moment';
import { CheckOutlined } from '@ant-design/icons';

export const ScheduledDateEdit = (props: {postScheduledId : string[], scheduledDate: string,	onFinish: () => void}) => {

    const { projectGroup } = useAuth();
    const [scheduleDateForm] = Form.useForm();
    const { t } = useTranslation();    
    
    const submitEditScheduleDate = async(formValues: {scheduledDate: string}) => {        

        const requestBody = {          
          scheduledDate: moment(formValues.scheduledDate).format('YYYY-MM-DD'), 
        };
  
        await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/post-scheduled/${props.postScheduledId}/scheduled-date`, { method: 'PATCH', data: requestBody })
        .then((res) => {          
          if (res) {
            message.success('Fecha de programación cambiada correctamente', 3);
            props.onFinish();            
          } else {
            message.error('Error al cambiar la fecha de programación', 3)
          }
      });
    }
    
    return (
      <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
        <div style={{
          borderRadius: 6,
          padding: '8px 16px',
          color: '#1976d2',
          fontWeight: 600,
          marginRight: 16,
          display: 'flex',
          alignItems: 'center'
        }}>          
          <div>Nueva programación:</div>
        </div>
   
        <Form
          form={scheduleDateForm}
          onFinish={(values) => submitEditScheduleDate(values)}
          initialValues={{ scheduledDate: moment(props.scheduledDate) }}
          style={{ marginLeft: '20px' }}
        >
          <Form.Item name="scheduledDate" style={{ marginBottom: 0 }}>
            <DatePicker format="DD-MM-YYYY" />
          </Form.Item>
        </Form>
        <Button
                onClick={() => {
                    Modal.confirm({
                        title: 'Cambio de fecha',
                        content: '¿Confirmas el cambio de fecha de programación?',
                        okText: t('dictionary.confirm'),
                        cancelText: t('dictionary.cancel'),
                        onOk: scheduleDateForm.submit
                    })
                }}
                type="text">
                <CheckOutlined />
        </Button>
      </div>
 
    )
}







